import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CircularProgress from '../../../../components/CircularProgress';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { GetBalanceSheetData, UpdateCustomField, ArchievedBalanceSheet, UpdateArchivedCustomField, GetEditArchivedData, GetLastQuarterGLReviewedDate, PUT_QuickbookAccount_UpdateAccountStatus, PUT_QuickbookAccount_UpdateExcludedReconciliation } from "../../../../appRedux/actions/BalanceSheetAction";
import { GetLastQuarterEndDate, getCompanyMaxDate, Getsum, LinkType } from "../../../common/commonServices";
// import { stat } from 'fs';
import Select from '@material-ui/core/Select';
import moment from 'moment';
import Button from '@material-ui/core/Button';
import BalanceSheetNodeComponent from "./BalanceSheetNode";
// import { da } from 'date-fns/locale';
import { toast } from 'react-toastify';
import ArchivedHistoryComponent from "./ArcvivedHistory";
import queryString from 'query-string';
import { AddQuestion } from "../../../../appRedux/actions/QuestionCommentsAction";
import { QboSystemAccounts } from "../../../../constants/Enums";
import './style.css';

class BalanceSheetAccountReviewComponent extends Component {


    constructor(props) {
        super(props)
        this.eDateRef = React.createRef();

        let sDate = new Date(new Date().getFullYear(), 0, 1);
        // if (sDate.getMonth() <= 2) {
        //     sDate.setFullYear(sDate.getFullYear() - 1, 0, 1);
        // }
        this.state = {
            loading: false,
            companyId: 0,
            sDate: sDate,
            AsOnDate: null,
            ACMethod: "Accrual",
            lst_data: [],
            otherData: [],
            archiveList: [],
            ShowArchivedHistory: false,
            isRequestProcessing: false,
            refArchivedData: this.props.location.state ? this.props.location.state : null,
            editArchivedType: "",
            editReportDate: new Date(),
            IsCompared: false,
            ShowZeroBalance: false,
            isGLReviewCompleted: false,
            oldOutstandingCount: 0,
            question: '',
            questionID: 0,
            questionData: null,
            reportDate: null,
            archivedDate: null
            // QuesRow: [],
        }
    }


    handleFocus = (e, selecter) => {
        let control = null;
        if (selecter !== undefined) {
            control = this.eDateRef;
            if (control.current != null) {
                control.current.setFocus();
            }
        }
    }

    componentDidMount() {

        let user = JSON.parse(localStorage.getItem('userData'));
        let companyId = user.companyId;
        this.setState({
            companyId: companyId,
            loading: true
        }, () => {
            this.props.GetLastQuarterGLReviewedDate(companyId);
        });
    }

    GetFirstReportData = () => {
        let user = JSON.parse(localStorage.getItem('userData'));
        let companyId = user.companyId;
        let AcMethod = this.state.ACMethod;
        let asOn = this.state.AsOnDate;
        let isComparedLink = this.state.IsCompared;
        if (this.props.location.search != null && this.props.location.search != "") {
            let value = queryString.parse(this.props.location.search);
            companyId = parseInt(value.cid);
            AcMethod = value.ACMethod;
            asOn = new Date(value.asOf);
            let temp = value.IsCompared;
            if (temp != null && temp.toLowerCase() == "true") {
                isComparedLink = true;
            }

        }
        if (AcMethod == null || AcMethod == "") {
            AcMethod = this.state.ACMethod;
        }
        this.setState({
            companyId: companyId,
            loading: true,
            ACMethod: AcMethod,
            AsOnDate: asOn,
            IsCompared: isComparedLink
        }, () => {
            if (this.state.refArchivedData == null) {
                this.GetReportData(false);

            }
            else {
                this.GetEditArchivedData();
            }

        });
    }



    GetReportData = () => {
        let eDate = moment(this.state.AsOnDate);
        let sDate = new Date(this.state.AsOnDate.getFullYear(), 0, 1);
        let param = "CompanyID=" + this.state.companyId
            + "&From=" + moment(sDate).format("MM/DD/YYYY")
            + "&To=" + eDate.format("MM/DD/YYYY")
            + "&AccountingMethod=" + this.state.ACMethod;

        this.props.GetBalanceSheetData(param);
    }

    componentWillReceiveProps(nextprops) {

        if (nextprops.BalanceSheetData !== undefined && nextprops.BalanceSheetData !== this.props.BalanceSheetData && this.state.refArchivedData == null) {
            if (nextprops.BalanceSheetData.transactionStatus === 0) {

                let items = [];
                let BLData = nextprops.BalanceSheetData.returnObject;
                if (BLData.reportData.Columns.Column.length >= 2) {
                    items = this.BindArray(items, BLData.reportData, 1, BLData.otherData);

                    // for(let k=0;k<items.length;k++)
                    // {
                    //     if(items[k].GLBalance==0)   
                    //     {   
                    //         items[k].GLBalance= this.GetChildSum(items,0,items[k]);
                    //     }
                    // }
                    if (items != null && items.length > 0) {
                        items = this.GroupingArray(items).filter(p => p.level === 1);
                    }

                    if (BLData.archiveList != null && BLData.archiveList.length > 0) {
                        let dt = BLData.archiveList[0];
                        // let message = `Last Balance sheet report as on <b>${dt.stReportDate}</b> was archived on <b>${dt.stArchiveDate}</b>. Click on <strong>view</strong> for history.`;
                        // toast.success(message);
                        this.setState({ reportDate: dt.stReportDate, archivedDate: dt.stArchiveDate });
                    }
                    // var QuestionDataRow = BLData.questingListingViewModels.filter(QData => QData.accountId > 0);
                    this.setState({ lst_data: items, isGLReviewCompleted: BLData.isGLReviewCompleted, isRequestProcessing: false, loading: false, archiveList: BLData.archiveList, ShowArchivedHistory: false });
                }
                else {
                    this.setState({ loading: false, isRequestProcessing: false, lst_data: [] }, () => { toast.error(`Data not found in QuickBook`); });
                }

            }
            else {
                this.setState({ loading: false, isRequestProcessing: false }, () => { toast.error(`${nextprops.BalanceSheetData.resultMsg}`); });
            }
        }

        if (nextprops.AddComman !== undefined && this.props.AddComman !== nextprops.AddComman) {
            if (nextprops.AddComman.transactionStatus === 0) {
                // toast.success("Record saved successfully.");                
                // this.setState({loading:false},() => { this.props.Reload();});

                this.setState({ loading: false, isRequestProcessing: true, questionData: null }, () => {
                    toast.success("Record saved successfully.");
                    if (this.state.refArchivedData == null) {
                        this.GetReportData();
                    }
                    else {
                        this.GetEditArchivedData();
                    }

                });
            }
            else {
                this.setState({ loading: false, isRequestProcessing: false }, () => { toast.error(`${nextprops.AddComman.resultMsg}`); });
            }
        }

        // if (nextprops.QuestionData !== undefined && this.props.QuestionData !== nextprops.QuestionData) {

        //     if (nextprops.QuestionData.transactionStatus === 0) {

        //         
        //         var QuestionDataRow =  nextprops.QuestionData.returnObject.filter(QData => QData.accountId > 0);
        //         this.setState({ loading: false, QuesRow: QuestionDataRow,isRequestProcessing: false });
        //     }
        //     else {
        //         this.setState({ loading: false,QuesRow:[],isRequestProcessing: false }, () => { toast.error(`${nextprops.QuestionData.resultMsg}`); });
        //     }
        // } 


        if (nextprops.GLReviewLastQueterDate !== undefined && this.props.GLReviewLastQueterDate !== nextprops.GLReviewLastQueterDate) {

            if (nextprops.GLReviewLastQueterDate.transactionStatus === 0) {


                var Data = nextprops.GLReviewLastQueterDate.returnObject;
                var GLReviewLastQueterDate = Data != null ? new Date(Data) : GetLastQuarterEndDate();
                var sDate = new Date(GLReviewLastQueterDate.getFullYear(), 0, 1);

                this.setState({
                    AsOnDate: GLReviewLastQueterDate,
                    sDate: sDate
                }, () => {
                    this.GetFirstReportData();
                });
            }
            else {
                this.setState({ loading: false }, () => { toast.error(`${nextprops.GLReviewLastQueterDate.resultMsg}`); });
            }
        }


        if (nextprops.UpdateData !== undefined && this.props.UpdateData !== nextprops.UpdateData) {
            if (nextprops.UpdateData.transactionStatus === 0) {

                if (this.state.questionData != null) {

                    //if(this.state.questionData.question != null && this.state.questionData.question != ''){
                    this.props.AddQuestion(this.state.questionData);
                    // } else {
                    //     this.setState({ loading: false, isRequestProcessing: true,questionData:null }, () => {
                    //         toast.success("Record saved successfully.");  
                    //         if (this.state.refArchivedData == null) {
                    //             this.GetReportData();
                    //         }
                    //         else {
                    //             this.GetEditArchivedData();
                    //         }

                    //     });
                    // }
                } else {
                    this.setState({ loading: false, isRequestProcessing: true, questionData: null }, () => {
                        toast.success("Record saved successfully.");
                        if (this.state.refArchivedData == null) {
                            this.GetReportData();
                        }
                        else {
                            this.GetEditArchivedData();
                        }

                    });
                }
            }
            else {
                this.setState({ loading: false, isRequestProcessing: false }, () => { toast.error(`${nextprops.UpdateData.resultMsg}`); });
            }
        }

        if (nextprops.EditArchivedData !== undefined && nextprops.EditArchivedData !== this.props.EditArchivedData && this.state.refArchivedData != null) {

            if (nextprops.EditArchivedData.transactionStatus === 0) {
                let items = [];

                if (nextprops.EditArchivedData.returnObject.reportData.Columns.Column.length >= 2) {
                    items = this.BindArray(items, nextprops.EditArchivedData.returnObject.reportData, 1, nextprops.EditArchivedData.returnObject.otherData);
                    if (items != null && items.length > 0) {
                        items = this.GroupingArray(items).filter(p => p.level === 1);
                    }
                    if (nextprops.EditArchivedData.returnObject.archiveList != null && nextprops.EditArchivedData.returnObject.archiveList.length > 0) {
                        // var QuestionDataRow = nextprops.EditArchivedData.returnObject.questingListingViewModels.filter(QData => QData.accountId > 0);
                        this.setState({ lst_data: items, isRequestProcessing: false, loading: false, archiveList: nextprops.EditArchivedData.returnObject.archiveList, ShowArchivedHistory: false, editReportDate: new Date(nextprops.EditArchivedData.returnObject.reportDate), editArchivedType: nextprops.EditArchivedData.returnObject.accountingMethod });//
                    }
                }
                else {
                    this.setState({ loading: false, isRequestProcessing: false, lst_data: [] }, () => { toast.error(`Data not found in QuickBook`); });
                }
            }
            else {
                this.setState({ loading: false, isRequestProcessing: false }, () => { toast.error(`${nextprops.EditArchivedData.resultMsg}`); });
            }
        }
    }

    // Drop accounts whose QuickBooks and Compliance balances are both 0 (bank and credit card stay), then empty
    // zero groups with their totals. Top-level sections and every total figure are untouched.
    HideZeroBalances = (nodes) => {
        const isZero = (n) => Math.round((parseFloat(n.Balance) || 0) * 100) === 0 && Math.round((parseFloat(n.GLBalance) || 0) * 100) === 0;
        const hiddenHeaders = [];
        const kept = [];
        nodes.forEach((node) => {
            if (node.IsHeader) {
                const items = this.HideZeroBalances(node.Items || []);
                if (node.level > 1 && isZero(node) && items.length === 0) hiddenHeaders.push(node);
                else kept.push({ ...node, Items: items });
            }
            else if (node.IsSummary) {
                if (!node.HeaderRef || hiddenHeaders.indexOf(node.HeaderRef) === -1) kept.push(node);
            }
            else if (!isZero(node) || node.Type === "Bank" || node.Type === "Credit Card") {
                kept.push(node);
            }
        });
        return kept;
    }

    // Make Inactive shows only while a listed account can be made inactive (zero balance, not a QuickBooks system account).
    HasInactiveCandidate = (nodes) => {
        const system = Object.values(QboSystemAccounts).map((a) => a.toLowerCase().trim());
        const isSystem = (n) => system.indexOf((n.Account || "").toLowerCase().trim()) !== -1 || system.indexOf((n.Type || "").toLowerCase().trim()) !== -1;
        return nodes.some((n) => (n.IsHeader ? this.HasInactiveCandidate(n.Items || []) : !n.IsSummary && n.Balance == 0 && !isSystem(n)));
    }

    GroupingArray = (arrayObj) => {

        arrayObj.map((data, index) => {
            if (data.IsHeader === true) {
                data.Items = arrayObj.filter(k => k.GroupName === data.Account);
            }
        })

        return arrayObj;
    }



    BindArray = (existingArray, items, level, otherData, GroupName = null) => {
        let temp = null;

        // Add null check for items.Rows.Row
        if (!items || !items.Rows || !items.Rows.Row) {
            return existingArray;
        }

        items.Rows.Row.map((data, index) => {
            let headerTemp = null; // links this section's total to its header (zero-balance hiding)

            if (data.Header !== undefined && data.Header != null) {
                temp = {
                    "Account": data.Header.ColData && data.Header.ColData[0] ? data.Header.ColData[0].value : "",
                    "Balance": 0,
                    "Notes": "",
                    "OldOutstandingCount": 0,
                    "Question": "",
                    "QuestionId": 0,
                    "ReconciledThrough": "",
                    "STRT": "",
                    "Type": "",
                    "level": level,
                    "IsHeader": true,
                    "IsSummary": false,
                    "IsExpandable": (data.type === "Section") ? true : false,
                    "GroupName": level === 1 ? "" : (GroupName == null ? (data.Header.ColData && data.Header.ColData[0] ? data.Header.ColData[0].value : "") : GroupName),
                    "Items": [],
                    "IsData": false,
                    "AccountId": 0,
                    "GLBalance": 0,
                    "QboAccountId": 0
                };

                if (data.Header.ColData && data.Header.ColData[0] && data.Header.ColData[0].id != null && data.Header.ColData[0].id != "" && data.Header.ColData[0].id > 0) {
                    let mapObj = this.GetMappDetails(data.Header.ColData[0].id, otherData);
                    if (mapObj != null) {
                        if (data.Header.ColData[1] && data.Header.ColData[1].value != null && data.Header.ColData[1].value.trim() != "") {
                            temp.Balance = parseFloat(data.Header.ColData[1].value);
                        }
                        else { temp.Balance = 0; }
                        temp.GLBalance = mapObj.length > 0 ? mapObj[0].glBalance : 0;
                    }
                }
                headerTemp = temp;
                existingArray.push(temp);
            }

            if (
                data &&
                data.type === "Section" &&
                data.Rows &&
                typeof data.Rows === "object" &&
                data.Rows.Row
            ) {
                this.BindArray(existingArray, data, (level + 1), otherData, data.Header && data.Header.ColData && data.Header.ColData[0] ? data.Header.ColData[0].value : "");
            }

            // Add proper null checks for ColData
            if (data.type === "Data" && data.ColData != null && Array.isArray(data.ColData) && data.ColData.length > 0) {

                let mapObj = this.GetMappDetails(data.ColData[0].id, otherData);

                temp = {
                    "Account": data.ColData[0] ? data.ColData[0].value : "",
                    "Balance": data.ColData.length > 1 && data.ColData[1] ? data.ColData[1].value : 0,
                    "Notes": mapObj && mapObj.length > 0 ? mapObj[0].comments : "",
                    "OldOutstandingCount": mapObj.length > 0 ? mapObj[0].oldOutstandingCount : 0,
                    "Question": mapObj && mapObj.length > 0 ? mapObj[0].question : "",
                    "QuestionId": mapObj && mapObj.length > 0 ? mapObj[0].questionId : 0,
                    "ReconciledThrough": mapObj && mapObj.length > 0 ? mapObj[0].reconciledThrough : "",
                    "STRT": mapObj && mapObj.length > 0 && mapObj[0].reconciledThrough != null ? moment(new Date(mapObj[0].reconciledThrough)).format("MM/DD/YYYY") : "",
                    "IsExcludedReconciliation": mapObj && mapObj.length > 0 ? mapObj[0].isExcludedReconciliation === true : false,
                    "Type": mapObj && mapObj.length > 0 ? mapObj[0].accountType : "",
                    "AccountSubType": mapObj && mapObj.length > 0 ? mapObj[0].accountSubType : "",
                    // null: unknown (review saved before the count existed) - shown as "-" for bank / credit card
                    "OldOutstandingTransactionCount": mapObj && mapObj.length > 0 && mapObj[0].oldOutstandingTransactionCount != null ? mapObj[0].oldOutstandingTransactionCount : null,
                    "level": level,
                    "IsExpandable": (data.type === "Section") ? true : false,
                    "IsHeader": false,
                    "IsSummary": false,
                    "GroupName": GroupName,
                    "Items": [],
                    "IsData": true,
                    "AccountId": mapObj && mapObj.length > 0 ? mapObj[0].accountID : 0,
                    "GLBalance": mapObj && mapObj.length > 0 ? mapObj[0].glBalance : 0,
                    "QboAccountId": data.ColData[0].id
                };

                if (temp.Account === "Retained Earnings" || temp.Account === "Net Revenue" || temp.Account === "Net Income") {
                    temp.GLBalance = temp.Balance;
                }
                existingArray.push(temp);
            }

            if (data.Summary != null && data.Summary !== undefined) {
                temp = {
                    "Account": data.Summary.ColData && data.Summary.ColData[0] ? data.Summary.ColData[0].value : "",
                    "Balance": data.Summary.ColData && data.Summary.ColData.length > 1 && data.Summary.ColData[1] ? data.Summary.ColData[1].value : 0,
                    "Notes": "",
                    "OldOutstandingCount": 0,
                    "Question": "",
                    "QuestionId": 0,
                    "ReconciledThrough": "",
                    "STRT": "",
                    "Type": "",
                    "level": level,
                    "IsExpandable": false,
                    "IsHeader": false,
                    "IsSummary": true,
                    "GroupName": level === 1 ? "" : (GroupName == null ? (data.Header && data.Header.ColData && data.Header.ColData[0] ? data.Header.ColData[0].value : "") : GroupName),
                    "HeaderRef": headerTemp,
                    "Items": [],
                    "IsData": false,
                    "AccountId": 0,
                    "GLBalance": 0,
                    "QboAccountId": 0
                };

                temp.GLBalance = this.GetTotal(data.Rows, 0, otherData);
                let result = this.HasChild(data.Rows);
                if (!result) {
                    if (data.Header && data.Header.ColData && data.Header.ColData[0] && data.Header.ColData[0].id != null && data.Header.ColData[0].id != "" && data.Header.ColData[0].id > 0) {
                        let mapObj = this.GetMappDetails(data.Header.ColData[0].id, otherData);
                        if (mapObj != null) {
                            temp.GLBalance += mapObj.length > 0 ? mapObj[0].glBalance : 0;
                        }
                    }
                }
                existingArray.push(temp);
            }
        });

        return existingArray;
    }

    HasChild = (items) => {
        let result = false;
        if (items != null && items.Row != null && items.Row.length > 0) {
            items.Row.map((data, index) => {
                if (data.Header !== undefined && data.Header != null && data.Header.ColData[0].id != null && data.Header.ColData[0].id != "" && data.Header.ColData[0].id > 0 &&
                    (data.type === "Section") && data.Rows !== undefined && data.Rows.Row != undefined) {

                    result = true;
                    return result;
                }

            });
        }

        return result;
    }

    GetTotal = (items, amount, otherData) => {

        if (items != null && items.Row != null && items.Row.length > 0) {
            items.Row.map((data, index) => {


                if (data.Header !== undefined && data.Header != null && data.Header.ColData[0].id != null && data.Header.ColData[0].id != "" && data.Header.ColData[0].id > 0) {

                    let mapObj = this.GetMappDetails(data.Header.ColData[0].id, otherData);
                    try {
                        if (mapObj != null && mapObj.length > 0) {
                            amount = amount + mapObj[0].glBalance;
                        }
                    }
                    catch (err) { }
                }


                if (data.type === "Data" && data.ColData != null && data.ColData.length > 0) {

                    if (data.ColData[0].value === "Retained Earnings" || data.ColData[0].value === "Net Revenue" || data.ColData[0].value === "Net Income") {
                        if (data.ColData.length >= 2 && data.ColData[1].value != "") {
                            amount = amount + parseFloat(data.ColData[1].value);
                        }
                    }
                    else {
                        let mapObj = this.GetMappDetails(data.ColData[0].id, otherData);
                        try {
                            if (mapObj != null && mapObj.length > 0) {
                                amount = amount + mapObj[0].glBalance;
                            }
                        }
                        catch (err) { }
                    }
                }

                // if ((data.type === "Section") && data.Rows !== undefined && data.Rows.Row != undefined) {
                if (
                    data &&
                    data.type === "Section" &&
                    data.Rows &&
                    typeof data.Rows === "object" &&
                    data.Rows.Row
                ) {
                    amount = amount + this.GetTotal(data.Rows, 0, otherData, false);

                }
            });
        }

        return amount;


    }

    handleFormChange = (e, target) => {
        if (!target) {
            this.setState({ ACMethod: e.target.value })
        }
        if (target === "AsOnDate") {
            const newAsOnDate = new Date(e);
            const newSDate = new Date(newAsOnDate.getFullYear(), 0, 1);
            this.setState({ AsOnDate: newAsOnDate, sDate: newSDate })
        }
    }

    ApplyDate = () => {
        this.setState({
            loading: true
        }, () => {
            this.GetReportData();
        });
    }

    ViewArchived = () => {
        this.props.history.push("archivedBL");
    }

    ArchivedData = () => {
        const sDate = new Date(this.state.AsOnDate.getFullYear(), 0, 1);
        let body = {
            "companyID": this.state.companyId,
            "fromDate": moment(sDate).format("MM/DD/YYYY"),
            "toDate": moment(this.state.AsOnDate).format("MM/DD/YYYY"),
            "accountingMethod": this.state.ACMethod
        }
        this.setState({
            loading: true
        }, () => {
            this.props.ArchievedBalanceSheet(body)
        });
    }

    OnCOmpareChange = (e) => {

        this.setState({ IsCompared: e.target.checked, loading: true }, () => {
            setTimeout(() => {
                this.setState({ loading: false })
            }, 1200);
        })
    }


    GetEditArchivedData = () => {
        this.props.GetEditArchivedData(this.state.refArchivedData.ArchivedData.id)
    }

    GetMappDetails = (id, items) => {
        if (items != null && items.length > 0) {
            return items.filter(data => data.listID === id);
        }
        else {
            return null;
        }
    }

    GetFormattedDate = (dateString) => {
        if (!dateString) return "";
        const d = new Date(dateString);
        if (isNaN(d)) return "";
        const options = {
            month: "2-digit",
            day: "2-digit",
            year: "numeric",
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
        };
        const parts = d.toLocaleString("en-US", options).split(",");
        return `${parts[0]} at${parts[1]}`;
    }

    accountStatusChange = async (event, item) => {
        event.stopPropagation();
        const isChecked = event.target.checked;

        if (parseInt(item.Balance) !== 0) {
            toast.error(
                "Error - This account has a balance on your books. You may make this account inactive after the account balance is zero for all transactions."
            );
            return;
        }

        try {
            const body = {
                accountId: item.AccountId,
                isActive: false,
            };

            const user = JSON.parse(localStorage.getItem("userData"));
            const companyId = user.companyId;

            this.setState({ companyId, loading: true }, async () => {
                let response = await this.props.PUT_QuickbookAccount_UpdateAccountStatus(body);
                if (response.data.transactionStatus === 0) {
                    toast.success("Account status updated successfully");
                }
                else if (response.data.transactionStatus === 1) {
                    toast.error("This account is currently being used in a transaction.");
                }
                await this.props.GetLastQuarterGLReviewedDate(companyId);
            });

        } catch (error) {
            toast.error("Something went wrong while updating account status.");

            if (this.state.refArchivedData == null) {
                await this.GetReportData();
            } else {
                await this.GetEditArchivedData();
            }

        }
    };

    // Returns whether the save succeeded so the row can roll back its checkbox.
    excludeReconciliationChange = async (isChecked, item) => {
        const body = {
            accountId: item.AccountId,
            reconciledThrough: item.ReconciledThrough ? moment(new Date(item.ReconciledThrough)).format('YYYY-MM-DD') : null,
            isExcludedReconciliation: isChecked
        };

        try {
            const response = await this.props.PUT_QuickbookAccount_UpdateExcludedReconciliation(body);
            if (response.data.transactionStatus === 0) {
                toast.success("Record saved successfully.");
                return true;
            }
            toast.error(`${response.data.resultMsg}`);
        } catch (error) {
            toast.error("Something went wrong while updating the account.");
        }
        return false;
    };

    UpdateFields = (data) => {

        let body = {};
        if (this.state.refArchivedData == null) {
            body = {
                "accountId": data.AccountId,
                "isReconciledThrough": data.isReconciledThrough,
                "reconciledThrough": (data.ReconciledThrough == null || data.ReconciledThrough === "") ? "1970-01-01" : moment(data.ReconciledThrough).format("MM/DD/YYYY"),
                "comments": data.Notes
            }
        }
        else {
            body = {
                "archiveID": this.state.refArchivedData.ArchivedData.id,
                "accountID": data.AccountId,
                "comments": data.Notes,
                "isReconciledThrough": data.isReconciledThrough,
                "reconciledThrough": (data.ReconciledThrough == null || data.ReconciledThrough === "") ? "1970-01-01" : moment(data.ReconciledThrough).format("MM/DD/YYYY")
            }
        }

        let QueBody = {
            "id": data.questionID != null && data.questionID != '' ? data.questionID : 0,
            "question": data.question,
            "status": false,
            "cpaReview": false,
            "companyID": this.state.companyId,
            "accountID": data.AccountId
        }

        // sprint 11 create a branch test
        this.setState({ loading: true, questionData: QueBody }, () => {
            if (this.state.refArchivedData == null) {
                this.props.UpdateCustomField(body);
            }
            else {
                this.props.UpdateArchivedCustomField(body);
            }


        });
    }

    CloseHistory = () => {
        this.setState({ ShowArchivedHistory: false });
    }

    render() {
        const shownData = this.state.ShowZeroBalance ? this.state.lst_data : this.HideZeroBalances(this.state.lst_data);
        const showInactive = this.state.ShowZeroBalance || this.HasInactiveCandidate(shownData);
        return (
            <div className="dashboardPage balance-sheet-review-page">
                <div className="page-heading page-title-box d-sm-flex justify-content-sm-between align-items-sm-center">
                    <h2 className="title mb-3 mb-sm-0 balance-sheet-review-title">{JSON.parse(localStorage.getItem('userData')) != null ? JSON.parse(localStorage.getItem('userData')).companyName : ""} | Balance Sheet Review</h2>
                </div>
                {this.state.ShowArchivedHistory && <ArchivedHistoryComponent
                    data={this.state.archiveList}
                    CloseHistory={this.CloseHistory}>
                </ArchivedHistoryComponent>
                }
                <div className="padding-box app-wrapper padding-b0">
                    <div className="row">

                        {this.state.refArchivedData == null &&
                            <div className="col-12 col-md-4">
                                <div className="dashboard-box " style={{ flexWrap: "wrap" }}>
                                    <div className="datepicker-box">
                                        <div style={{ textAlign: "left" }}> <label className="pl-2">As of :</label>
                                            <div className="date-box">
                                                <DatePicker
                                                    selected={this.state.AsOnDate}
                                                    onChange={(e) => this.handleFormChange(e, 'AsOnDate')}
                                                    label="Loan Date"
                                                    id="date"
                                                    name="AsOn"
                                                    margin="normal"
                                                    disabledKeyboardNavigation
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    yearDropdownItemNumber={15}
                                                    maxDate={getCompanyMaxDate()}
                                                    ref={this.eDateRef}
                                                />
                                                <div className="date-icon" onClick={(e) => this.handleFocus(e, 'eDate')}>
                                                    <i className="zmdi zmdi-calendar-note"></i>
                                                </div>
                                            </div>
                                        </div>
                                        <div style={{ textAlign: "left" }}>
                                            <label className="pl-4">A/C Method</label>
                                            <div className="date-box" style={{ padding: "0px 20px" }}>
                                                <Select
                                                    name="accountingMethod"
                                                    required={true}
                                                    native
                                                    value={this.state.ACMethod}
                                                    onChange={this.handleFormChange}
                                                >
                                                    <option value={""} disabled>Select Accouting Method</option>
                                                    {/* <option value={"Cash"}>Cash</option> */}
                                                    <option value={"Accrual"}>Accrual</option>
                                                </Select>
                                            </div>

                                        </div>
                                    </div>
                                    <div className="genera-apply-btn" style={{ marginTop: "10px", textAlign: "left" }}>
                                        <Button variant="contained" className="greencolor jr-btn bg-teal text-white refresh-btn" onClick={(e) => this.ApplyDate()} >Apply</Button>
                                    </div>
                                </div>
                            </div>
                        }
                        {this.state.refArchivedData != null &&
                            <div className="col-12 col-md-4">
                                <div className="dashboard-box " style={{ flexWrap: "wrap" }}>
                                    <div className="datepicker-box">
                                        <div style={{ textAlign: "left" }}> <label className="pl-2">As On :</label>
                                            <div className="date-box">
                                                <DatePicker
                                                    selected={this.state.editReportDate}
                                                    label="Loan Date"
                                                    id="date"
                                                    name="AsOn"
                                                    margin="normal"
                                                    disabled
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    yearDropdownItemNumber={15}
                                                    ref={this.eDateRef}
                                                />
                                                <div className="date-icon" onClick={(e) => this.handleFocus(e, 'eDate')}>
                                                    <i className="zmdi zmdi-calendar-note"></i>
                                                </div>
                                            </div>
                                        </div>
                                        <div style={{ textAlign: "left" }}>
                                            <label className="pl-4">A/C Method</label>
                                            <div className="date-box" style={{ padding: "0px 20px" }}>
                                                <Select
                                                    name="accountingMethod"
                                                    native
                                                    value={this.state.editArchivedType}
                                                    disabled
                                                >
                                                    <option value={""} disabled>Select Accouting Method</option>

                                                    {/* {this.state.editArchivedType == "Cash" ?
                                                        <option value={"Cash"} selected="selected"> Cash</option>
                                                        :
                                                        <option value={"Cash"}> Cash</option>
                                                    } */}

                                                    {this.state.editArchivedType == "Accrual" ?
                                                        <option value={"Accrual"} selected="selected">Accrual</option>
                                                        :
                                                        <option value={"Accrual"}>Accrual</option>
                                                    }


                                                </Select>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        <div className="col-12 col-md-8">
                            <div className="btncheck_compare">
                                <div className="singlecheckbox">
                                    {this.state.refArchivedData == null && this.state.loading === false &&
                                        <div className="checkbox pointer" >
                                            <div className="chiller_cb">
                                                <input id="TFB" type="checkbox" checked={this.state.IsCompared} onChange={(e) => this.OnCOmpareChange(e)} />
                                                <label htmlFor="TFB">
                                                    <p className="checkbox-title">Compare</p>

                                                </label>
                                                <span></span>
                                            </div>
                                        </div>
                                    }
                                    {this.state.loading === false &&
                                        <div className="checkbox pointer" title="Bank and credit card accounts are always shown">
                                            <div className="chiller_cb">
                                                <input id="ShowZeroBalance" type="checkbox" checked={this.state.ShowZeroBalance} onChange={(e) => this.setState({ ShowZeroBalance: e.target.checked })} />
                                                <label htmlFor="ShowZeroBalance">
                                                    <p className="checkbox-title">Show Zero-Balance Accounts</p>
                                                </label>
                                                <span></span>
                                            </div>
                                        </div>
                                    }
                                </div>

                                <div className="float-right">
                                    {this.state.refArchivedData == null &&
                                        <React.Fragment>
                                            {
                                                // this.state.isGLReviewCompleted && 
                                                <Button variant="contained" className="greencolor jr-btn bg-teal text-white refresh-btn" onClick={(e) => this.ArchivedData()} >Mark as Reviewed</Button>}
                                        </React.Fragment>


                                    }
                                    <Button variant="contained" className="greencolor jr-btn bg-teal text-white refresh-btn view-btn" onClick={() => this.ViewArchived()} >View History</Button>

                                </div>
                            </div>
                            <div className="float-right" style={{ marginTop: "20px" }}>
                                {this.state.reportDate &&
                                    this.state.archivedDate && (
                                        <p>
                                            Last Balance sheet report as on <b>{this.state.reportDate}</b> was reviewed on{" "}<br />
                                            <b>{this.state.archivedDate}</b>.
                                        </p>
                                    )}
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.loading ?
                    <div className="bs-loading-wrap">
                        <CircularProgress></CircularProgress>
                    </div>
                    :
                    <React.Fragment>
                        <div className="padding-box app-wrapper account-reconcilliation balancereview-page" style={{ paddingTop: "0px" }}>
                            <div className="table-responsive-material">
                                <table className={"table balance-sheet-page fixed-table" + (showInactive ? "" : " bs-hide-inactive")} >
                                    <thead className="panel-bg white_header_text">
                                        <tr>{this.state.IsCompared ?
                                            <React.Fragment>
                                                <th className="width-300" >Account No.</th>
                                                <th className="td-width balance-td-width" >Compliance Balance</th>
                                                <th className="td-width balance-td-width" >Quickbook Balance</th>
                                                <th className="td-width  text-center balance-td-width"> Difference </th>
                                                <th className="text-center" title="Old outstanding transactions dated on or before the As On date">Old<br></br>Outstanding</th>
                                                <th className="text-center">Exclude From Account<br></br>Reconciliation Review</th>
                                                <th>Internal Notes</th>
                                                <th>Questions and Comments for the Client</th>
                                                <th className="text-center" style={{ width: "100px" }}>Make<br></br>Inactive</th>
                                                <th className="td-width-90 text-center "><img src="/vendors/Link-arrow_header.png" alt="link" /></th>
                                            </React.Fragment> :
                                            <React.Fragment>
                                                <th className="width-300" >Account No.</th>
                                                <th className="td-width type-td-width" >Type</th>
                                                <th className="td-width text-center balance-td-width"> Balance </th>
                                                <th className="td-width balance-td-width" >Reconciled Through</th>
                                                <th className="text-center" title="Old outstanding transactions dated on or before the As On date">Old<br></br>Outstanding</th>
                                                <th className="text-center">Exclude From Account<br></br>Reconciliation Review</th>
                                                <th>Internal Notes</th>
                                                <th>Questions and Comments for the Client</th>
                                                <th className="text-center" style={{ width: "100px" }}>Make<br></br>Inactive</th>
                                                <th className="td-width-90 text-center "><img src="/vendors/Link-arrow_header.png" alt="link" /></th>
                                            </React.Fragment>
                                        }</tr>
                                    </thead>
                                    <tbody>
                                        {!this.state.isRequestProcessing &&
                                            <BalanceSheetNodeComponent
                                                key={this.state.ShowZeroBalance ? "with-zero" : "without-zero"}
                                                data={shownData}
                                                // quedata={this.state.QuesRow}
                                                level={1}
                                                UpdateFields={this.UpdateFields}
                                                IsCompared={this.state.IsCompared}
                                                accountStatusChange={this.accountStatusChange}
                                                excludeReconciliationChange={this.state.refArchivedData == null ? this.excludeReconciliationChange : null}
                                                reloadData={this.GetReportData}
                                            >
                                            </BalanceSheetNodeComponent>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </React.Fragment>
                }
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        BalanceSheetData: state.BalanceSheetData.BalanceSheetData,
        UpdateData: state.BalanceSheetData.UpdateData,
        EditArchivedData: state.BalanceSheetData.EditArchivedData,
        AddComman: state.QuestionCommentsData.AddComman,
        GLReviewLastQueterDate: state.BalanceSheetData.GLReviewLastQueterDate,
        // QuestionData: state.QuestionCommentsData.QuestionData,
    }
}
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        GetBalanceSheetData,
        UpdateCustomField,
        ArchievedBalanceSheet,
        GetEditArchivedData,
        PUT_QuickbookAccount_UpdateAccountStatus,
        PUT_QuickbookAccount_UpdateExcludedReconciliation,
        UpdateArchivedCustomField,
        AddQuestion,
        GetLastQuarterGLReviewedDate
        //GetQuestionList
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(BalanceSheetAccountReviewComponent);